import React from 'react';
import { Text, Button, Header, BackButton, Loading } from 'ui';
import { useTagProducts, useAuth, updateTag } from 'api';
import { useHistory, useParams } from 'react-router-dom';
import "./index.css";

export default function CreateCampaign() {
  const auth = useAuth();
  const companyId = auth ? auth.company.id : null;
  const {tagId} = useParams();
  const products = useTagProducts(auth ? auth.company.plan.id : null);
  const history = useHistory();
  
  if(!products || !auth) {
    return <Loading/>;
  }
  
  async function update(product, variant) {
    await updateTag(companyId, tagId, {
      // preview: product.image,
      product: {
        id: product.id,
        title: product.title,
      },
      variant: {
        id: variant.id,
        title: variant.title,
      }
    });
    history.push("view");
  }
  
  return (
    <div className="tagssize">
      <Header>
        <BackButton/> <Text large light style={{flex:1}}>Design a Tag</Text>
      </Header>
      <div style={{padding:24}}>
        <Text bold block style={{marginBottom:12}}>Choose a shape and size</Text>
        
        <div className="tagssize-products">
          {products.map(product => 
            
            <div className="tagssize-product" key={product.id}>
              <div className="tagssize-product-image">
                <img src={product.image} alt={product.title}/>
              </div>
              {product.variants.map(variant => 
                <Button 
                  key={variant.id}
                  color="#fa637d" 
                  label={variant.title} 
                  onClick={() => update(product, variant)}
                />
              )}
            </div>
            
          )}
        </div>
        
        <div className="tagssize-custom">
          <div>
            <Text bold block style={{marginBottom:12}}>Custom Shapes and Sizes</Text>
            <Text>
              Lorem ipsum dolor sit amet, consectetuer<br/>
              adipiscing elit, sed diam nonummy nibh<br/>
              euismod tincidunt ut laoreet dolore magna<br/>
              aliquam erat volutpat. Ut wisi enim ad minim<br/>
              veniam, quis nostrud exerci tation ulla
            </Text>
          </div>
          <div className="tagssize-custom-preview">
            <img src="https://placehold.it/600x150" alt="examples"/>
          </div>
        </div>
        
        
      </div>
    </div>
  );
}


          